<ng-container *ngIf="isSmallScreen; else largeScreen">
  <dx-data-grid
  id="gridContainer"
  [dataSource]="SdSvc.dataSource"
  keyExpr="Id"
  [columnAutoWidth]="true"
  [showBorders]="true"
  dataRowTemplate="dataRowTemplateName"
  width="90%"
  class="mt-2 m-auto"
>
  <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"></dxi-column>
  <dxi-column dataField="FenixVersion" [caption]="'fenix-version' | translateWithFallback"  dataType="string">
  </dxi-column>

  <ng-container *dxTemplate="let serviceData of 'dataRowTemplateName'">
    <tr class="main-row" role="row">
      <td role="gridcell">{{ serviceData.data.Name }}</td>
      <td role="gridcell">{{ serviceData.data.FenixVersion ?? '-' }}</td>
      <td role="gridcell" [rowSpan]="3">
        <dx-button [hint]="'remove' | translateWithFallback" stylingMode="outlined" class="m-2" (click)="onDeleteData(serviceData.data)">
          <fa-icon [icon]="faTrashCan"></fa-icon>
        </dx-button>
      </td>
    </tr>
    <tr class="notes-row" role="row">
      <td role="gridcell">Owner:</td>
      <td role="gridcell">{{ getOwnerName(serviceData.data.OwnerId) }}</td>
    </tr>
    <tr class="notes-row" role="row">
      <td role="gridcell">User:</td>
      <td role="gridcell">{{ getUserName(serviceData.data.UserId) }}</td>
    </tr>
  </ng-container>

  <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
    <div *dxTemplate="let serviceData of 'detail'">
      <app-service-data-detail [id]="serviceData.data.Id"></app-service-data-detail>
    </div>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true" [showNavigationButtons]="true">
    </dxo-pager>
</dx-data-grid>

</ng-container>
<ng-template #largeScreen>
  <dx-data-grid
    id="ServiceDataGrid"
    [dataSource]="SdSvc.dataSource"
    [showBorders]="true"
    [remoteOperations]="true"
    [rowAlternationEnabled]="true"
    [columnHidingEnabled]="true"
    [columnAutoWidth]="true"
    keyExpr="Id"
    width="90%"
    height="80vh"
    class="mt-5 m-auto"
  >

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"></dxi-column>
    <dxi-column dataField="UserId" [caption]="'user' | translateWithFallback" dataType="string">
      <dxo-lookup
        [dataSource]="SdSvc.usersCache$ | async"
        valueExpr="Id"
        displayExpr="Name">
      </dxo-lookup>
    </dxi-column>
    <dxi-column dataField="OwnerId" [caption]="'owner' | translateWithFallback"  dataType="string">
      <dxo-lookup
        [dataSource]="OSvc.AllOwners"
        valueExpr="Id"
        displayExpr="Name">
      </dxo-lookup>
    </dxi-column>
    <dxi-column dataField="FenixVersion" [caption]="'fenix-version' | translateWithFallback"  dataType="string">
    </dxi-column>
    <dxi-column cellTemplate="selectionCellTemplate" [caption]="'actions' | translateWithFallback"></dxi-column>

    <div *dxTemplate="let cellInfo of 'selectionCellTemplate'">
      <dx-button [hint]="'remove' | translateWithFallback" stylingMode="outlined" class="m-2" (click)="onDeleteData(cellInfo.data)">
        <fa-icon [icon]="faTrashCan"></fa-icon>
      </dx-button>
    </div>

    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
    <div *dxTemplate="let serviceData of 'detail'">
      <app-service-data-detail [id]="serviceData.data.Id"></app-service-data-detail>
    </div>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <!--    infinite scrolling breaks paginator-->
    <!--    <dxo-scrolling rowRenderingMode="virtual" mode="infinite"> </dxo-scrolling>-->
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true"
               [showNavigationButtons]="true"
               [showPageSizeSelector]="true"
               [allowedPageSizes]="[10, 25, 50, 100]">
    </dxo-pager>
  </dx-data-grid>
</ng-template>
